import { Box } from '@mui/material'
import clsx from 'clsx'

import './PageLayout.scss'

interface PageLayoutProps {
  breadcrumb?: React.ReactNode
  header?: React.ReactNode
  headerActions?: React.ReactNode
  middleContent?: React.ReactNode
  sideMenu?: React.ReactNode
  hasTopMenu?: boolean
  children: React.ReactNode
  secondaryContent?: React.ReactNode
  variant?: 'sm' | 'md' | 'lg' | 'xl' | 'full'
  background?: 'default' | 'secondary'
}

const PageLayout = ({
  breadcrumb,
  header,
  headerActions,
  middleContent,
  sideMenu,
  hasTopMenu = true,
  children,
  secondaryContent,
  variant = 'full',
  background = 'default',
}: PageLayoutProps): React.ReactElement => {
  const mainContentClass = clsx(
    'layout-main-content',
    `layout-main-content--${variant}`,
    sideMenu && 'layout-main-content--with-secondary',
    hasTopMenu && 'layout-main-content--has-top-menu',
  )

  const containerClass = clsx(
    'layout-container',
    background !== 'default' && `layout-container--background-${background}`,
  )

  return (
    <Box className='page-layout'>
      <Box className={containerClass}>
        {sideMenu && (
          <Box component='aside' className='layout-side-menu'>
            {sideMenu}
          </Box>
        )}
        <Box component='main' className={mainContentClass}>
          {(breadcrumb || middleContent || header || headerActions) && (
            <Box className='layout-header'>
              {(breadcrumb || middleContent || header) && (
                <Box className='layout-header-content'>
                  {breadcrumb}
                  {middleContent}
                  {header}
                </Box>
              )}
              {headerActions && <Box className='layout-header-actions'>{headerActions}</Box>}
            </Box>
          )}
          {children}
        </Box>
        {secondaryContent && (
          <Box component='aside' className='layout-secondary-content'>
            {secondaryContent}
          </Box>
        )}
      </Box>
    </Box>
  )
}

export default PageLayout
